import { defineComponent as t, openBlock as r, createElementBlock as o, mergeProps as s, renderSlot as n } from "vue";
import "./ghl-ui.es225.js";
const m = t({
  name: "UITextMdMedium",
  inheritAttrs: !1
}), d = t({
  ...m,
  setup(a) {
    return (e, l) => (r(), o("div", s(e.$attrs, { class: "hl-text-md-medium" }), [
      n(e.$slots, "default")
    ], 16));
  }
}), p = d;
export {
  p as default
};
